var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"document-form"},[_c('div',{staticClass:"form-item"},[_c('span',[_vm._v("Policyholder HKID")]),_c('file-container',{attrs:{"edit":true,"fileData":_vm.formData.id_type_pic,"otherData":{
        target: 'id_type_pic'
      },"titleName":"Policyholder HKID"},on:{"delete":_vm.handlerDeleteFile,"uploadSuccess":_vm.handlerUploadSuccess}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }